import controller from './orders.controller';

import templateBase from './templates/orders.view.html';
import adaptativo from './templates/orders-adaptativo.view.html';

let ReportOrdersComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate() {
  if(__env.adaptative){
    return adaptativo;
  } else {
    return templateBase;
  }
}


export default ReportOrdersComponent;



/** WEBPACK FOOTER **
 ** ./www/components/reports/orders/orders.component.js
 **/